import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NotificationData} from '../../../services/common/websocket-notification.service';
import {Utilities} from '../../../utils/utilities';

@Component({
    selector: 'app-reservation-notification',
    templateUrl: './reservation-notification.component.html',
    styleUrls: ['./reservation-notification.component.scss']
})
export class ReservationNotificationComponent implements OnInit {
    @Input() notification: NotificationData;
    @Input() cookieKey: string;
    @Output() linkClick = new EventEmitter<any>();


    constructor() {
    }

    ngOnInit() {

        if (typeof this.notification.data.attribute.reservationDate === 'object') {
            this.notification.data.attribute.reservationDate = new Date(
                Utilities.getDateFromJacksonJSON(this.notification.data.attribute.reservationDate) +' '
                +Utilities.getTimeFromJacksonJSON(this.notification.data.attribute.reservationTime)
            );
        }
        if(this.notification.data.attribute.restaurant && this.notification.data.attribute.restaurant.name){
            this.notification.data.attribute.restaurantName = this.notification.data.attribute.restaurant.name;
        }
    }

    readNotification() {
        let link = '/reservations/restaurant/'+this.notification.data.attribute.restaurant.historyId+'/'+this.notification.data.attribute.id;
        if (this.notification.data.type.indexOf('DELIVERY') > -1) {
            link = '/reservations/delivery/'+this.notification.data.attribute.restaurant.historyId+'/'+this.notification.data.attribute.id;
        }
        // const link = "/orders/delivery/"+this.notification.data.attribute.id;
        this.linkClick.emit({key:this.notification.key, link, cookieKey:this.cookieKey});
    }

}
